import { useState, Fragment, memo } from 'react'
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Grid,
  Typography
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import BVuelos from '../../ProveedoresVuelos/TVuelos/BVuelos'
import { FormatoFechaIso } from '../../../utils/FormatFecha'
import { formatDinero } from '../../../utils/formatDinero'
import { useSelector } from 'react-redux'

const RowCircuito = memo(({ circuito }) => {
  const [open, setOpen] = useState(false)
  const { circuitoSelect } = useSelector(store => store.proveedorTerrestre);
  const { totalVuelosPorCircuito } = useSelector(store => store.vueloProveedor);

  const disabledVuelos = (() => {
    const regiones = circuito?.LPaqueteCircuitoRegion || []

    if (regiones.length === 0) return false

    const algunaIncluyeVuelo = regiones.some(region => region.IncluyeVuelo === true)

    return !algunaIncluyeVuelo
  })()

  return (
    <Fragment>
      <TableRow hover>
        <TableCell align="center">{circuito.ClaveCircuito}</TableCell>
        <TableCell align="center">{FormatoFechaIso({ date: circuito.FechaInicio, formato: "dd/MM/yyyy" })}</TableCell>
        <TableCell align="center">{FormatoFechaIso({ date: circuito.FechaFin, formato: "dd/MM/yyyy" })}</TableCell>
        <TableCell align="center">{circuito.Disponibilidad}</TableCell>
        {/* <TableCell align="center">{circuito.Dias}</TableCell>
        <TableCell align="center">{circuito.Noches}</TableCell>
        <TableCell align="center">{formatDinero(circuito.Suplemento)}</TableCell> */}
        <TableCell align="center">{circuito?.LVueloProveedor?.length || 0}</TableCell>
        <TableCell align="center">
          <BVuelos paquete={circuito} disabled={disabledVuelos}/>
        </TableCell>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={2}>
              <Grid container spacing={2}>
                {/* Información detallada del circuito */}
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Detalles del Circuito
                  </Typography>
                  <Typography variant="body2">
                    <strong>Clave:</strong> {circuito.ClaveCircuito}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha de inicio:</strong> {FormatoFechaIso({ date: circuito.FechaInicio })}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha de fin:</strong> {FormatoFechaIso({ date: circuito.FechaFin })}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Vuelos Asignados:</strong> {circuito.IdPaqueteCircuito === circuitoSelect?.IdPaqueteCircuito 
                      ? totalVuelosPorCircuito 
                      : circuito?.LVueloProveedor?.length || 0}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Días/Noches:</strong> {circuito.Dias} días / {circuito.Noches} noches
                  </Typography>
                  <Typography variant="body2">
                    <strong>Suplemento:</strong> {formatDinero(circuito.Suplemento)}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Disponibilidad:</strong> {circuito.Disponibilidad}
                  </Typography>
                </Grid>

                {/* Regiones asignadas al circuito */}
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Regiones Asignadas
                  </Typography>

                  {circuito?.LPaqueteCircuitoRegion?.length > 0 ? (
                    <Grid container spacing={2}>
                      {circuito.LPaqueteCircuitoRegion.map((region) => (
                        <Grid item xs={12} md={6} key={region.IdPaqueteCircuitoRegion}>
                          <Box
                            border={1}
                            borderRadius={8}
                            borderColor="primary.main"
                            p={1}
                            display="flex"
                            flexDirection="column"
                            bgcolor="#f9f9f9"
                          >
                            <Typography variant="subtitle1" color="primary">
                              {region.CatRegion?.Descripcion}
                            </Typography>
                            <Typography variant="body2">
                              Incluye Vuelo:{" "}
                              <strong>{region.IncluyeVuelo ? "Sí" : "No"}</strong>
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No hay regiones asignadas a este circuito.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  )
})

export default RowCircuito
